import { ReactElement } from 'react'
import { Route } from 'react-router-dom'
import { pages } from 'navigation/pages'
import EinvoicingWeeklyCtrl from '../components/EinvoicingCtrl/EinvoicingWeeklyCtrl'
import EinvoicingLayout from './EinvoicingLayout'
import EinvoicingArtisansCtrl from '../components/EinvoicingArtisansCtrl/EinvoicingArtisansCtrl'
import EinvoicingDayCtrl from '../components/EinvoicingCtrl/EinvoicingDayCtrl/EinvoicingDayCtrl'
import EinvoicingActions from '../components/EinvoicingActions'
import EinvoicingReceivedCtrl from '../components/EinvoicingReceivedCtrl/EinvoicingReceivedCtrl'

export default function EinvoicingRouter(): ReactElement {
  return (
    <Route path={pages.connected.eInvoicing.root} element={<EinvoicingLayout />}>
      <Route path={pages.connected.eInvoicing.daily.name} element={<EinvoicingDayCtrl />} />
      <Route path={pages.connected.eInvoicing.weekly.name} element={<EinvoicingWeeklyCtrl />} />
      <Route path={pages.connected.eInvoicing.compliance.name} element={<EinvoicingArtisansCtrl />} />
      <Route path={pages.connected.eInvoicing.actions.name} element={<EinvoicingActions />} />
      <Route path={pages.connected.eInvoicing.received.name} element={<EinvoicingReceivedCtrl />} /> {/* TODO: create received ctrl */ }
    </Route>
  )
}
